import * as React from "react";
import PropTypes from "prop-types";
const SvgAchievementsBadgeNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M12 4.238l4 2.25v4.545l-4 2.25-4-2.25V6.488zm-2 3.42v2.205l2 1.125 2-1.125V7.658l-2-1.125z" />
        <path d="M10.512.449a3 3 0 012.976 0l5 2.857A3 3 0 0120 5.911v5.679a3 3 0 01-1.512 2.604l-.613.35v7.376c0 1.572-1.819 2.446-3.046 1.464L12 21.12l-2.829 2.263c-1.227.982-3.046.108-3.046-1.464v-7.375l-.613-.35A3 3 0 014 11.59V5.91a3 3 0 011.512-2.604zM7.875 15.545v6.375c0 .035.009.055.017.067.01.016.029.033.054.045.025.012.05.016.068.014a.115.115 0 00.064-.029L12 18.88l3.922 3.137a.115.115 0 00.064.029.132.132 0 00.068-.014.132.132 0 00.054-.045.116.116 0 00.017-.067v-6.375l-2.637 1.506a3 3 0 01-2.976 0zm4.621-13.36a1 1 0 00-.992 0l-5 2.858A1 1 0 006 5.91v5.679a1 1 0 00.504.868l5 2.857a1 1 0 00.992 0l5-2.857A1 1 0 0018 11.59V5.91a1 1 0 00-.504-.867z" />
      </g>
    </svg>
  )
);
SvgAchievementsBadgeNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgAchievementsBadgeNormalSmall;
